'use client';
import { SUBFLOW_PATHS, SUBFLOW_STEPS_V3 } from '@/core/constants';
import { getStep } from '@/utils/subflowAnalyticsHelpers';
import interpolate from '@/utils/translations/interpolate';
import { usePathname } from '@/navigation';
import React, { FC, useEffect, useState } from 'react';

interface StepHeaderInterface {
  t: string;
}

const StepHeader: FC<StepHeaderInterface> = ({ t }) => {
  const path = usePathname() || '';
  const [stepNum, setStepNum] = useState(0);
  const [totalStepCount, setTotalStepCount] = useState(0);

  useEffect(() => {
    const currentStepNum = getStep(path)?.stepNum || 0;
    // This is not necessarily the total amount of steps, but the last step this StepHeader counts to
    const finalStepCount =
      SUBFLOW_STEPS_V3.find(
        (step) => step.path === SUBFLOW_PATHS.PAYMENT_OPTIONS,
      )?.stepNum || 0;

    setStepNum(currentStepNum);
    setTotalStepCount(finalStepCount);
  }, [path]);

  if (!stepNum || !totalStepCount) return null;

  return (
    <div className="mx-auto text-center w-full mb-6 md:mb-8">
      <p>
        {interpolate(t, {
          currentStep: stepNum,
          totalSteps: totalStepCount,
        })}
      </p>
    </div>
  );
};

export default StepHeader;
